import {createSvgIcon} from '../create-svg-icon';

export const ArrowLeftIcon = createSvgIcon(
  <path d="M14.71 6.71a1 1 0 0 1 0 1.41L11.83 11H20a1 1 0 1 1 0 2h-8.17l2.88 2.88a1 1 0 1 1-1.42 1.41l-4.59-4.59a1 1 0 0 1 0-1.41l4.59-4.59a1 1 0 0 1 1.42 0z" />
, 'ArrowLeft');